import { useTranslations } from '@vocab/react';
import { Box, Checkbox, Stack } from 'braid-design-system';

import { FilterAccordion } from '../FilterAccordion/FilterAccordion';
import { SearchFilter } from '../SearchFilter/SearchFilter';
import type { Suggestion } from '../types';

import translations from './.vocab';

interface Props {
  expanded: boolean;
  selectedItems: Suggestion[];
  suggestions: Suggestion[];
  onCompanyChange: (newSelectedItems: Suggestion[]) => void;
  onExpandedToggle: (expanded: boolean) => void;
  matchLatestCompany: boolean;
  onMatchLatestCompanyChange: (newState: boolean) => void;
  onDebouncedSearchTextChange: (newSearchText: string) => void;
  onSearchTextChange?: (newSearchText: string) => void;
}

export const CompanyFilter = ({
  expanded,
  selectedItems,
  suggestions,
  onCompanyChange,
  onExpandedToggle,
  matchLatestCompany,
  onMatchLatestCompanyChange,
  onDebouncedSearchTextChange,
  onSearchTextChange,
}: Props) => {
  const { t } = useTranslations(translations);

  return (
    <FilterAccordion
      id="company-accordion-filter"
      expanded={expanded}
      label={t('COMPANY')}
      selectedItems={selectedItems}
      onToggle={onExpandedToggle}
    >
      <Stack space="small">
        <SearchFilter
          id="company-filter"
          label=""
          placeholder={t('ENTER_COMPANY_NAME')}
          suggestions={suggestions}
          selectedItems={selectedItems}
          onDebouncedSearchTextChange={onDebouncedSearchTextChange}
          onSearchTextChange={onSearchTextChange}
          onChange={onCompanyChange}
        />
        <Box paddingLeft="xxsmall">
          <Checkbox
            size="small"
            id="company-filter-checkbox"
            label={t('MATCH_WITH_LATEST_COMPANY_ONLY')}
            checked={matchLatestCompany}
            onChange={() => onMatchLatestCompanyChange(!matchLatestCompany)}
          />
        </Box>
      </Stack>
    </FilterAccordion>
  );
};
